<ihd-nav-bar *ngIf="showNavBar"></ihd-nav-bar>



<ui-view></ui-view>

<ui-view name="dialog"></ui-view>
<ui-view name="overlay"></ui-view>

<ihd-mobile-blocker></ihd-mobile-blocker>
<!-- <ihd-app-loader></ihd-app-loader> -->
